import type { StateCreator } from 'zustand';
import type { GoogleDriveConnection } from '../types';
import { googleDriveApi } from '../services/googleDriveApi';

export interface GoogleDriveSlice {
  driveConnection: GoogleDriveConnection | null;
  driveLoading: boolean;

  fetchDriveStatus: () => Promise<void>;
  startDriveOAuth: () => Promise<void>;
  disconnectDrive: () => Promise<void>;
}

export const createGoogleDriveSlice: StateCreator<GoogleDriveSlice, [], [], GoogleDriveSlice> = (set) => ({
  driveConnection: null,
  driveLoading: false,

  fetchDriveStatus: async () => {
    set({ driveLoading: true });
    try {
      const status = await googleDriveApi.getStatus();
      set({ driveConnection: status });
    } finally {
      set({ driveLoading: false });
    }
  },

  startDriveOAuth: async () => {
    const { oauth_url } = await googleDriveApi.getOAuthUrl();
    window.location.href = oauth_url;
  },

  disconnectDrive: async () => {
    await googleDriveApi.disconnect();
    set({ driveConnection: { connected: false } });
  },
});
